module.exports = __webpack_public_path__ + "img/拍照妈妈.227ffb4c.png";